import styled from "styled-components";

import {
  facebook,
  facebook2x,
  instagram,
  instagram2x,
  twitter,
  twitter2x
} from "../../assets";

export const SocialLinks = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 40px 0 16px;
`;

export const SocialLink = styled.li`
  &:not(:last-child) {
    margin-right: 24px;
  }
`;

const SocialIcon = styled.img`
  height: 24px;
  width: 24px;
`;

export const TwitterIcon = styled(SocialIcon).attrs({
  alt: "StreetEasy Twitter",
  src: twitter,
  srcSet: `${twitter2x} 2x`
})``;
export const FacebookIcon = styled(SocialIcon).attrs({
  alt: "StreetEasy Facebook",
  src: facebook,
  srcSet: `${facebook2x} 2x`
})``;
export const InstagramIcon = styled(SocialIcon).attrs({
  alt: "StreetEasy Instagram",
  src: instagram,
  srcSet: `${instagram2x} 2x`
})``;
